(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.vq-nav-group[open]').forEach(function(group){if(!group.contains(event.target))group.open=false;});});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.vq-nav-group[open]').forEach(function(group){if(group.contains(document.activeElement))group.querySelector('summary').focus();group.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if(!customElements.get('velqino-gallery')){
customElements.define('velqino-gallery',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const track=this.querySelector('.vq-gallery-track'),slides=this.querySelectorAll('[data-slide]'),thumbs=this.querySelectorAll('[data-thumb]'),prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]'),counter=this.querySelector('[data-counter]');
if(!track||slides.length<2)return;
let current=0;
const go=index=>track.scrollTo({left:Math.max(0,Math.min(slides.length-1,index))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
const sync=()=>{current=Math.round(track.scrollLeft/track.clientWidth);prev.disabled=current===0;next.disabled=current===slides.length-1;counter.textContent=(current+1)+' / '+slides.length;thumbs.forEach((thumb,index)=>thumb.setAttribute('aria-current',String(index===current)));};
prev.addEventListener('click',()=>go(current-1));next.addEventListener('click',()=>go(current+1));thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>go(index)));
track.addEventListener('scroll',sync,{passive:true});
track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();go(current+(event.key==='ArrowRight'?1:-1));}});
this.resizeObserver=new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'});});this.resizeObserver.observe(track);
}
disconnectedCallback(){this.resizeObserver?.disconnect();this.initialized=false;}
});
}

  } catch(e) { console.error(e); }
})();
})();
